// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_merchant-settings_merchant-settings_module_ts":"4c69bec1a643abda","src_app_components_password-reset-confirmation_password-reset-confirmation_module_ts":"4eea914227a5dcb7"}[chunkId] + ".js";
};